module.exports = __webpack_public_path__ + "img/email_footer_img.b8b5bcb8.png";